var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape22 = function SvgShape22(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 94,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.414 37.679C.414 16.928 17.236.105 37.988.105h68.023c20.752 0 37.574 16.823 37.574 37.574 0 17.113-11.441 31.554-27.091 36.092a.24.24 0 0 0-.173.229c0 .106.071.2.173.23 15.65 4.537 27.091 18.978 27.091 36.091 0 20.751-16.822 37.574-37.574 37.574H37.988c-20.752 0-37.574-16.823-37.574-37.574 0-17.001 11.292-31.366 26.786-36.002a.33.33 0 0 0 .238-.319.334.334 0 0 0-.238-.32C11.706 69.046.413 54.68.413 37.68",
    opacity: 0.1
  })));
};
export default SvgShape22;